import React from 'react';
import styles from './footer.module.scss';
import { GitHub } from '@mui/icons-material';
import { Button, Typography, Link } from '@mui/material';
import { Copyright } from '@mui/icons-material';

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div>
          <Button variant="text" color="inherit" startIcon={<GitHub />}>
            <Link href="https://github.com/k3kit" underline="none" color="text.secondary">
              <Typography>k3kit</Typography>
            </Link>
          </Button>
        </div>
        <div className={styles.copyright}>
          <Copyright />
          <Typography>2023</Typography>
        </div>
      </div>
    </footer>
  );
};
